<template>
    <div class="welcome-page-container">
        <article class="welcome-page">
            <Header />
            <div class="screen">
                <div class="flex-row">
                    <h1>認定登録フォーム</h1>
                    <div class="description">
                        合格おめでとうございます。<br />
                        認定登録は以下よりお進みください。
                    </div>
                </div>
                <div class="submit-box flex justify-center">
                    <router-link class="submit-button" to="/login">認定登録はこちら</router-link>
                </div>
                <div class="footer">
                    <a href="https://jtca2020.or.jp/" target="_blank" rel="noreferrer">
                        <img class="logo" src="/images/jtca_logo_horizontal.png" alt="JTCA" />
                    </a>
                </div>
            </div>
        </article>
    </div>
</template>

<script>
import Header from "../../parts/app/Header";

export default {
    name: "Welcome",
    components: {Header}
}
</script>

<style scoped>

</style>
